<template>
  <div v-if="message" :class="['w-full py-3 px-4 rounded', backgroundColor]" :data-test-id="dataTestId">
    <div class="flex flex-row items-center gap-2">
      <div class="flex flex-row items-start grow gap-3">
        <span class="flex-col justify-center items-start gap-2.5 inline-flex">
          <img class="max-w-fit" :src="icon" :alt="`${productStatus} icon`" />
        </span>
        <RichText data-test-id="infoText" class="text-sm" :field="{ value: message }" />
      </div>
      <button
        v-if="showButton"
        class="!min-w-24 btn btn-sm btn-primary"
        data-test-id="actionButton"
        @click="primaryBtnClick"
      >
        {{ showPayNowButton ? payButtonText : renewButtonText }}
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import { IIProductStatus } from '@/interfaces';

const props = defineProps<IIProductStatus>();

const icon = computed(() => iconMap[props.productStatus]);
const backgroundColor = computed(() => backgroundColorMap[props.productStatus]);
const dataTestId = computed(() => props.dataTestId + dataTestIdMap[props.productStatus]);

const iconMap = {
  active: require('@/assets/icons/info-information.svg'),
  scheduled: require('@/assets/icons/icon-warning-wrapper.svg'),
  cancelled: require('@/assets/icons/icon-wrapper-error.svg'),
  paid: require('@/assets/icons/icon-wrapper-success.svg'),
};

const backgroundColorMap = {
  active: 'bg-racq-info-light-blue',
  scheduled: 'bg-racq-info-light-yellow',
  cancelled: 'bg-racq-info-light-red',
  paid: 'bg-racq-info-light-green',
};

const dataTestIdMap = {
  active: '_info_box',
  scheduled: '_info_box',
  cancelled: '_warning_box',
  paid: '_info_box',
};

const primaryBtnClick = () => {
  const url = props.showPayNowButton
    ? props.makeAPaymentLink?.value?.href + (props.prn ? '?prn=' + props.prn : '')
    : props.renewalOfferFormLink?.value?.href + '?policyId=' + props.policyNumber;
  window.open(url, '_blank');
};
</script>
